import authGuard from '@/guards/auth.guard';
import { Route } from 'vue-router';

const forumRoutes = [
  {
    path: '/forum',
    beforeEnter: (to: Route, from: Route, next: any) => {
      authGuard(to, from, next);
    },
    component: () =>
      import(
        /* webpackChunkName: "forum" */ '../views/forum/ForumRouterView.vue'
      ),
    children: [
      {
        path: '',
        name: 'ForumIndex',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/ForumIndex.vue'
          ),
        meta: { transitionDepth: 0 }
      },
      {
        path: 'category/:categoryId/create-topic',
        name: 'CreateTopic',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/CreateTopic.vue'
          ),
        props: true,
        meta: { transitionDepth: 2 }
      },
      {
        path: 'category/:categoryId/edit-topic/:topicId',
        name: 'EditTopic',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/CreateTopic.vue'
          ),
        meta: { transitionDepth: 2 }
      },
      {
        path: 'topics',
        name: 'AllTopics',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/TopicOverview.vue'
          ),
        meta: { transitionDepth: 1 }
      },
      {
        path: 'your-topics',
        name: 'YourTopics',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/YourTopics.vue'
          ),
        meta: { transitionDepth: 1 }
      },
      {
        path: 'topic/:topicId',
        name: 'Topic',
        component: () =>
          import(/* webpackChunkName: "forum" */ '../views/forum/Topic.vue'),
        props: true,
        meta: { transitionDepth: 1 }
      },
      {
        path: 'topic/:topicId/message',
        name: 'TopicMessage',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/TopicMessage.vue'
          ),
        props: true,
        meta: { transitionDepth: 2 }
      },
      {
        path: 'topic/:topicId/reply/:messageId',
        name: 'TopicMessageReply',
        component: () =>
          import(
            /* webpackChunkName: "forum" */ '../views/forum/TopicMessage.vue'
          ),
        props: true,
        meta: { transitionDepth: 2 }
      },
      {
        path: 'category/:categoryId',
        name: 'Category',
        component: () =>
          import(/* webpackChunkName: "forum" */ '../views/forum/CategoryTopicOverview.vue'),
        props: true,
        meta: { transitionDepth: 1 }
      }
    ]
  }
];

export default forumRoutes;
